import(/* webpackMode: "eager", webpackExports: ["BlogCTACard"] */ "/Users/yiminghan/lavareach/src/components/blog/blog-cta.tsx");
